import * as React from "react";
import { IssueExportButton } from "../IssueExportButton";
import { useCallback, useContext } from "react";
import { ActivePanelTypeContext } from "../IssuesPanel/ActivePanelTypeContext";
import { PanelType } from "../PanelType";

export const IssuesTableExportButton = () => {
  const [activePanel, setActivePanel] = useContext(ActivePanelTypeContext);
  const handleExportButtonClick = useCallback(() => {
    setActivePanel(
      activePanel !== PanelType.ExportPanel
        ? PanelType.ExportPanel
        : PanelType.None
    );
  }, [activePanel, setActivePanel]);
  return <IssueExportButton onExportButtonClicked={handleExportButtonClick} />;
};
